// extracted by mini-css-extract-plugin
export var buttons = "_9z-0";
export var buttonsActive = "_9z-h";
export var cancelConfirm = "_9z-1";
export var closeButton = "_9z-2";
export var column = "_9z-3";
export var container = "_9z-4";
export var detailHeader = "_9z-6";
export var detailTitle = "_9z-7";
export var detailsContent = "_9z-5";
export var header = "_9z-8";
export var headerWithClose = "_9z-9";
export var icon = "_9z-a";
export var infoIcon = "_9z-c";
export var informationContainer = "_9z-b";
export var sideDrawer = "_9z-d";
export var sideDrawerOpen = "_9z-e";
export var stickyFooter = "_9z-f";
export var typeOption = "_9z-g";